module.exports = __webpack_public_path__ + "static/media/doctor2.bffbee62.png";